import { GetReports } from './getReports'
import {DEFAULT_PAGE} from "../../contstants";

const FilterReports = async (perPage,filters) => {

    const page = filters.page || DEFAULT_PAGE;
    const status = filters.status || '';

    let statusFilter = true;
    if(status === 'inactive'){
        statusFilter = false;
    }

    return await GetReports(perPage, (page - 1) * perPage, statusFilter);
};

export default FilterReports;
